module.exports = __webpack_public_path__ + "img/strategy.1ad2c19d.svg";